import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { Modes, Statuses } from '../constants/Enums';
import {
    fetchApps, fetchPermissions,
    fetchSecurityGroup
} from '../api/SecurityGroupApi';
import { fetchUsers } from '../api/AuthenticationApi';
import { getOffices } from '../api/RosterApi';
import { resetOperationStatus, toggleSecurityModal, updateSecurityGroup } from '../actions/SecurityGroupActions';
import CreateSecurityGroupForm from '../components/SecurityGroups/create/CreateSecurityGroupForm';
import UpdateSecurityGroupForm from '../components/SecurityGroups/Update/UpdateSecurityGroupForm';
import CopySecurityGroup from '../components/SecurityGroups/Copy/CopySecurityGroup';

class SecurityGroupController extends Component {
    constructor(props) {
        super(props);

        this.state = {
            values: [],
            button1Active: true,
            button2Active: false,
            permissions: [],
            apps: [],
            securityGroup: null,
            showError: false,
            errorMessage: 'An unknown error occurred',
            securityGroupUpdateStatus: Statuses.NOT_STARTED,
            permissionUpdateStatus: Statuses.NOT_STARTED,
            usersUpdateStatus: Statuses.NOT_STARTED,
            appUpdateStatus: Statuses.NOT_STARTED,
            err: null,
            shouldDisplayError: false,
            validationMessage: null,
            mode: null
        };
    }

    setErrorMessage = (message) => {
        let error = message || this.state.error;
        let errorMessage = error.message;
        setTimeout(() => {
            this.setState({ showError: false });
        }, 2500);
        this.setState({ showError: true, errorMessage });
    };

    redirect = (route) => {
        this.props.resetOperationStatus();
        this.props.history.push(route);
    };


    setApps = (appId) => {
        let securityGroup = this.state.securityGroup;
        if (securityGroup.appIds && securityGroup.appIds.includes(appId)) {
            this.props.removeApp(appId);
        } else {
            this.props.addApp(appId);
        }
    };

    UNSAFE_componentWillMount() {
        this.props.fetchPermissions();
        this.props.fetchApps();
        this.props.fetchUsers();
        this.props.getOffices();
        this.props.resetOperationStatus();
        if (this.props.match.params.id)
            this.props.fetchSecurityGroup(this.props.match.params.id);
        this.setState({ mode: this.props.mode });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.securityGroup !== this.state.securityGroup) {
            this.setState({ securityGroup: nextProps.securityGroup });
        }
        if (nextProps.error !== this.state.error) {
            this.setState({ error: nextProps.error });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.error !== this.state.error && this.state.error !== null) {
            this.setErrorMessage();
        }
    }

    render() {
        switch (this.state.mode) {
            case Modes.CREATE: {
                return (
                    <CreateSecurityGroupForm redirect={this.redirect}
                                             toggleSecurityModal={this.props.toggleSecurityModal}
                                             isModalOpen={this.props.isModalOpen} showError={this.state.showError}
                                             errorMessage={this.state.errorMessage}
                                             setErrorMessage={this.setErrorMessage} />
                );
            }
            case Modes.COPY: {
                return (
                    <CopySecurityGroup redirect={this.redirect}
                                       toggleSecurityModal={this.props.toggleSecurityModal}
                                       isModalOpen={this.props.isModalOpen} showError={this.state.showError}
                                       errorMessage={this.state.errorMessage}
                                       setErrorMessage={this.setErrorMessage} />
                );
            }
            case Modes.EDIT: {
                return (
                    <UpdateSecurityGroupForm redirect={this.redirect} user={this.props.user}
                                             toggleSecurityModal={this.props.toggleSecurityModal}
                                             isModalOpen={this.props.isModalOpen} roleId={this.props.match.params.id}
                                             showError={this.state.showError} errorMessage={this.state.errorMessage} />
                );
            }
            default:
                return null;
        }
    }
}

SecurityGroupController.propTypes = {
    mode: PropTypes.number.isRequired,
    resetOperationStatus: PropTypes.func,
    user: PropTypes.object,
    isModalOpen: PropTypes.bool,
    error: PropTypes.object,
    history: PropTypes.object,
    removeApp: PropTypes.func,
    addApp: PropTypes.func,
    fetchPermissions: PropTypes.func,
    fetchApps: PropTypes.func,
    fetchUsers: PropTypes.func,
    fetchSecurityGroup: PropTypes.func,
    getOffices: PropTypes.func,
    match: PropTypes.object,
    securityGroup: PropTypes.object,
    toggleSecurityModal: PropTypes.func
};

function mapStateToProps(state) {
    return {
        user: state.authenticationReducer.user,
        isModalOpen: state.securityGroup.isModalOpen,
        error: state.securityGroup.err
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        fetchPermissions,
        fetchApps,
        fetchUsers,
        getOffices,
        resetOperationStatus,
        fetchSecurityGroup,
        updateSecurityGroup,
        toggleSecurityModal
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SecurityGroupController));